import * as actionTypes from '@store/actions/actionTypes'

const initialState = {
  activityStatuses: null,
  activityMonths: 6,
  activityForSaleRent: 'Any',
  includeForeclosureStatus: false
}

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.TAX_TOGGLE_ACTIVITY_STATUS:
      return {
        ...state,
        activityStatuses: state.activityStatuses.map(status => {
          if (status.display !== action.display) {
            return status
          }
          return { ...status, selected: !status.selected }
        })
      }
    case actionTypes.TAX_SELECT_ALL_ACTIVITY_STATUSES:
      return {
        ...state,
        activityStatuses: state.activityStatuses.map(status => ({
          ...status,
          selected: true
        })),
        includeForeclosureStatus: true
      }
    case actionTypes.TAX_DESELECT_ALL_ACTIVITY_STATUSES:
      return {
        ...state,
        activityStatuses: state.activityStatuses.map(status => ({
          ...status,
          selected: false
        })),
        includeForeclosureStatus: false
      }
    case actionTypes.TAX_BULK_SET_ACTIVITY_STATUSES:
      return {
        ...state,
        activityStatuses: action.activityStatuses
      }
    case actionTypes.TAX_SET_ACTIVITY_MONTHS:
      return {
        ...state,
        activityMonths: action.months
      }
    case actionTypes.TAX_SET_ACTIVITY_FORSALE_RENT:
      return {
        ...state,
        activityForSaleRent: action.value
      }
    case actionTypes.TAX_RESET_ACTIVITY_FILTERS:
      return {
        ...state,
        activityStatuses: initialState.activityStatuses,
        activityMonths: initialState.activityMonths,
        activityForSaleRent: initialState.activityForSaleRent,
        activityFiltersChanged: initialState.activityFiltersChanged,
        includeForeclosureStatus: initialState.includeForeclosureStatus
      }
    case actionTypes.TAX_INCLUDE_FORECLOSURE_STATUS:
      return {
        ...state,
        includeForeclosureStatus: !state.includeForeclosureStatus
      }
    default:
      return state
  }
}

export default reducer
